import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss']
})
export class NavigationItemComponent implements OnInit {
  @Input()  showItem = true;
  @Input()  iconClass: string;
  @Input()  itemLabel: string;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();

  _activeUrl: string;
  @Input() set activeUrl(url: string) {
    this._activeUrl = '';
    if (url) {
      this._activeUrl = `${url}`;
    }
  }
  _targetUrl: string;
  @Input() set targetUrl(url: string) {
    this._targetUrl = '';
    if (url) {
      this._targetUrl = `/${url}`;
    }
  }

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }
  onRouterClick(event) {
    this.clickEvent.emit(event);
  }

}
